import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
import { ACTION_TYPE_TO_STREAMING_PROFILE_MODE_MAP, STREAMING_PROFILE_TO_ACTION_TYPE_MAP } from "../../internal/internalConstants.js";
/**
 * @extends SDK.Action
 * @memberOf Actions.Transcode
 * @description The predefined streaming profiles.
 *
 * <b>Learn more</b>: {@link https://cloudinary.com/documentation/video_manipulation_and_delivery#predefined_streaming_profiles|Predefined streaming profiles}
 * @see Visit {@link Actions.Transcode|Transcode} for an example
 */

var StreamingProfileAction = /*#__PURE__*/function (_Action) {
  _inherits(StreamingProfileAction, _Action);

  var _super = _createSuper(StreamingProfileAction);

  function StreamingProfileAction(profile) {
    var _this;

    _classCallCheck(this, StreamingProfileAction);

    _this = _super.call(this);
    _this._actionModel = {
      actionType: 'streamingProfile'
    };

    _this.addQualifier(new Qualifier('sp', profile));

    _this._actionModel.profile = STREAMING_PROFILE_TO_ACTION_TYPE_MAP[profile] || profile;
    return _this;
  }

  _createClass(StreamingProfileAction, null, [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var profile = actionModel.profile; // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [actionModel])
      // This allows the inheriting classes to determine the class to be created

      var profileType = ACTION_TYPE_TO_STREAMING_PROFILE_MODE_MAP[profile] || profile;
      var result = new this(profileType);
      return result;
    }
  }]);

  return StreamingProfileAction;
}(Action);

export default StreamingProfileAction;